import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useSelector } from "react-redux";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import photo from "../../../../src/components/afterPartnerRegistration/photo.png";
import pdf from "../../../../src/components/afterPartnerRegistration/pdf.png";
import "../../../../src/components/afterPartnerRegistration/style.css";
import { useDropzone } from "react-dropzone";

const UserDocuments = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const user_id = loggedInUser?.user.id;
  console.log("Logged in user ID:", user_id);
  const [files, setFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = loggedInUser?.refreshToken;

  const requiredDocumentTypes = ["aadhar", "pan", "reraregistration"];

  // Dropzone logic
  const onDrop = (acceptedFiles) => {
    const updatedFiles = acceptedFiles.map((file) => ({
      file,
      documentType: "",
      uploaded: false,
    }));
    setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // Remove file
  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  // Change document type
  const handleDocumentTypeChange = (index, newType) => {
    const updatedFiles = [...files];
    updatedFiles[index].documentType = newType;
    setFiles(updatedFiles);
  };

  // Upload file
  const uploadFile = async (file, documentType, index) => {
    const formData = new FormData();
    formData.append("name", documentType);
    formData.append("user_id", user_id);
    formData.append("file", file);
    console.log(file);
    console.log(documentType);
    console.log(index);
    console.log(formData);

    try {
      const response = await axios.post(
        `${baseUrl}/user/document/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        }
      );
      console.log("Upload Response:", response);
      if (response.data.statusType === "SUCCESS") {
        const updatedFiles = [...files];
        updatedFiles[index].uploaded = true;
        setFiles(updatedFiles);

        setUploadedFiles((prev) => {
          const newUploadedFiles = { ...prev, [documentType]: true };
          secureLocalStorage.setItem("uploadedFiles", JSON.stringify(newUploadedFiles));
          return newUploadedFiles;
        });

        showToast(`${response?.data?.document?.name} uploaded successfully`, { type: "success" });
      }
    } catch (error) {
      showToast("Error Uploading Document", { type: "danger" });
    }
  };

  // Load uploaded files from local storage
  useEffect(() => {
    const storedUploadedFiles = secureLocalStorage.getItem("uploadedFiles");
    if (storedUploadedFiles) setUploadedFiles(JSON.parse(storedUploadedFiles));
  }, []);

  // File icon
  const getFileIcon = (file) => {
    const extension = file.name.split(".").pop().toLowerCase();
    if (extension === "pdf") return <img src={pdf} alt="PDF" style={{ width: "3rem" }} />;
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    if (["jpg", "png", "jpeg"].includes(extension)) return <img src={photo} alt="Image" style={{ width: "3rem" }} />;
    return null;
  };

  return (
    <Container fluid >
      <Notification />
      <Row className="justify-content-center">
        <Col xs={12} lg={10}>
          <div className="card shadow border-0 rounded-3 p-4 my-2 profile-card">
            <h4 style={{ fontWeight: "600" }}>Required Documents</h4>
            {requiredDocumentTypes.map((docType, index) => (
              <span key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <p className="mb-0">
                  {docType === "reraregistration" ? (
                    <>
                      {index + 1}. RERA REGISTRATION Certificate
                    </>
                  ) : (
                    <>
                      {index + 1}. {docType.toUpperCase()} Card
                    </>
                  )}
                </p>
                {uploadedFiles[docType] ? (
                  <span className="text-success">Uploaded</span>
                ) : (
                  <span style={{ color: "red" }}>Not Uploaded</span>
                )}
              </span>
            ))}

            <div className="mt-3">
              <h4 style={{ fontWeight: "500" }} >Upload Documents</h4>
              <p style={{ color: "red", fontStyle: "italic", fontSize: "14px" }}>
                Note: Please upload at least one required file in PDF format, PNG, or JPEG.
              </p>
              <div
                {...getRootProps({ className: "dropzone" })}
                style={{
                  border: "2px dashed #007bff",
                  padding: "20px",
                  textAlign: "center",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  marginBottom: "20px",
                }}
              >
                <input {...getInputProps()} />
                <p>
                  <span style={{ color: "#007bff" }}>Upload </span>
                  or drag and drop files here
                </p>
              </div>
            </div>

            {files.length > 0 && (
              <div style={{ backgroundColor: "#ffffff", borderRadius: "8px", padding: "10px", marginTop: "1rem" }}>
                {files.map((fileWrapper, index) => (
                  <React.Fragment key={index}>
                    <Row style={{ marginBottom: "10px", alignItems: "center" }}>
                      <Col md={1} sm={2}>{getFileIcon(fileWrapper.file)}</Col>
                      <Col md={5} sm={3} style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        <span>{fileWrapper.file.name}</span>
                      </Col>
                      <Col lg={4} md={3} sm={4}>
                        <Form.Select
                          value={fileWrapper.documentType}
                          onChange={(e) => handleDocumentTypeChange(index, e.target.value)}
                          style={{ width: "100%" }}
                        >
                          <option value="">Select document type</option>
                          <option value="aadhar">Aadhar Card</option>
                          <option value="pan">PAN Card</option>
                          <option value="reraregistration">Rera Registration</option>
                        </Form.Select>
                      </Col>
                      <Col lg={2} md={3} sm={3} className="buttonBlock" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                        <Button
                          variant="outline-success"
                          className="upload_button"
                          size="sm"
                          onClick={() => uploadFile(fileWrapper.file, fileWrapper.documentType, index)}
                          disabled={!fileWrapper.documentType || fileWrapper.uploaded}
                        >
                          <span>Upload</span>
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeFile(index)}
                          disabled={fileWrapper.uploaded}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                    <hr className="mt-3" />
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UserDocuments;
